let Country = require("country-state-city").Country;
let State = require("country-state-city").State;

(function ($) {
	// State selection functionality
	$(document).ready(function () {
		const countries = Country.getAllCountries();

		function getStatesForCountry(country) {
			const countryData = State.getStatesOfCountry(country);

			return countryData || [];
		}

		function getOptionCountries(currentCountry) {
			const options = countries.map((country) => {
				return (
					'<option value="' +
					country.isoCode +
					'"' +
					(country.isoCode === currentCountry ? " selected" : "") +
					">" +
					country.name +
					"</option>"
				);
			});
			return options.join("");
		}

		function createStateSelect(id, inputSelector, countrySelector) {
			var $input = $(inputSelector),
				$country = $(countrySelector);
			var $select = $(
				'<select class="state-select" id="' + id + '_select"></select>',
			);
			var currentValue = $input.val();
			var currentCountry = $country.find(":selected").val();

			console.log("Current value:", currentValue);
			console.log("Current country:111", currentCountry);

			$select.insertBefore($input);
			// Sync select to input
			$select.on("change", function () {
				$input.val($(this).val());
			});

			//$country.html(getOptionCountries(currentCountry));

			function getOptions(states) {
				const options = [];

				options.push(
					'<option value="">' +
						$input.attr("placeholder") +
						"</option>",
				);
				$.each(states, function (i, state) {
					if (state.isoCode === currentValue) {
						options.push(
							`<option value="${state.isoCode}" selected="selected">${state.name}</option>`,
						);
					} else {
						options.push(
							`<option value="${state.isoCode}">${state.name}</option>`,
						);
					}
				});

				return options.join("");
			}

			function updateStateSelect() {
				var country = $country.val(),
					states = getStatesForCountry(country);

				var options = jQuery(getOptions(states));

				$select.html(options);
			}

			if ($input.length && $country.length) {
				updateStateSelect();
				$country.on("change", () => {
					updateStateSelect();
					$input.val("");
				});
			}
		}

		// Example selectors for Gravity Forms address fields:
		// Adjust selectors as needed for your form markup

		jQuery(".gfield--type-address").each(function (index, el) {
			const $el = $(el);
			const $country = $el.find(".ginput_address_country select");
			const $state = $el.find(".ginput_address_state input");
			createStateSelect("shipping_state_" + index, $state, $country);
		});
		//jQuery(document).find("#input_2_4_6").val("US").trigger("change");
	});
})(jQuery);
